import React from 'react';
import PropTypes from 'prop-types';
import '../styles/ButtonComponent.scss';

const ButtonComponent = ({ className, onClick, children, disabled, type }) => {
  return (
    <button className={`custom-button ${className}`} onClick={onClick} disabled={disabled} type={type}>
      {children} 
    </button>
  );
};

ButtonComponent.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  type: PropTypes.string,
};

export default ButtonComponent;
